<template>
  <div>
<el-table
    v-if="page == 1"
    :data="tableData"
    @row-click="handdle"
    style="width: 100%">

    <el-table-column
      label="盘点单号"
      prop="checkId"
      width="80">
    </el-table-column>


    <el-table-column
      label="盘点单名称"
      prop="checkName"
      width="180">
    </el-table-column>

    <el-table-column
      label="盘点单状态"
      prop="checkState"
      width="180">
      <template slot-scope="scope">

        <el-tag
        :type="scope.row.checkState == 1?''
        :(scope.row.checkState==2?'success'
        :(scope.row.checkState==3?'danger'
        :(scope.row.checkState == 4?'primary'
        :(scope.row.checkState == 5?'success':'warning'))))"
        effect="dark">
          <div v-if="scope.row.checkState == 1">进行中</div>
          <div v-if="scope.row.checkState == 2">待审核</div>
          <div v-if="scope.row.checkState == 3">已完成</div>
          <div v-if="scope.row.checkState == 4">已终止</div>
          <div v-if="scope.row.checkState == 5">已驳回</div>
        </el-tag>



      </template>
    </el-table-column>


    <el-table-column
      label="盘点单分类类型"
      prop="checkSortType"
      width="180">
      <template slot-scope="scope">
        <el-tag
        :type="scope.row.checkSortType == 1?'':(scope.row.checkSortType==2?'success':(scope.row.checkSortType==3?'info':(scope.row.checkSortType==4?'danger':'warning')))"
        effect="dark">
          <div v-if="scope.row.checkSortType == 1">按照资产管理部门划分 </div>
          <div v-if="scope.row.checkSortType == 2">按照资产类别划分</div>
          <div v-if="scope.row.checkSortType == 3">按照管理人分类</div>
          <div v-if="scope.row.checkSortType == 4">根据房间号分类</div>
        </el-tag>
      </template>
    </el-table-column>




    <el-table-column
      label="创建时间"
      prop="createDate"
      width="180">
    </el-table-column>



    <el-table-column
      label="预计的完成时间"
      prop="endDate"
      width="180">
    </el-table-column>



    <el-table-column
      label="审核人人姓名"
      prop="checkerName"
      width="180">
    </el-table-column>


    <el-table-column
      label="创建人姓名"
      prop="createName"
      width="180">
    </el-table-column>



    <el-table-column
      label="单位名称"
      prop="unitName"
      width="180">
    </el-table-column>



    <el-table-column
      label="实际的完成时间"
      prop="realOverDate"
      width="180">
    </el-table-column>

    <el-table-column label="操作">
        <template slot-scope="scope">
          <el-select  v-model.trim="tableData[scope.$index].Num" placeholder="是否为资产状态">
            <!-- <el-option label="进行中" value='1'></el-option>
            <el-option label="待审核" value='2'></el-option> -->
            <el-option label="已完成" value='3'></el-option>
            <el-option label="已驳回" value='4'></el-option>
            <el-option label="已终止" value='5'></el-option>
          </el-select>
          <el-button type="text" @click="ShengHe(scope.row)">确定任务状态</el-button>
        </template>
    </el-table-column>


  </el-table>
  <div v-if="page == 2">
      <CheckMissionDeatil></CheckMissionDeatil>
  </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import Cookies from "js-cookie";
  import CheckMissionDeatil from "./CheckMissionDeatil.vue"
  export default {
     name: 'CheckMission',
     components:{
       CheckMissionDeatil
     },
     data () {
       return {
        page:1,
        checkId:'',
        taskId:'',
      tableData: [{
                checkId:'',
                unitId:'',
                checkState:'',
                checkName:'',
                checkUserId:'',
                createUserId:'',
                checkSortType:'',
                createDate:'',
                endDate:'',
                checkerName:'',
                createName:'',
                unitName:'',
                realOverDate:'',
                Num:'',
              }]
        };
     },
     mounted:function() {
       this.showData();
     },
     methods: {
		// 盘点单审核键，提交盘点审核
       ShengHe(val){
         var authorization = Cookies.get("Authorization");
         var params = {
           checkId:parseInt(val.checkId),
           state:parseInt(val.Num),
         }
          this.axios({
              method: 'POST',
              url: '/check/updateState',
              params:params,
              header:{
               'Authorization':authorization,
              	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
              	}
            }).then((resp)=>{
               this.showData();
            })


       },


	   // 切换到下一页，同时将盘点单Id和盘点子任务Id都传过去
       handdle(row,event,column){
         this.page = 2
         this.checkId = row.checkId
         this.taskId = row.taskId
       },

	  // 盘点审核信息单的数据
      showData(){
        var authorization = Cookies.get("Authorization");
        var params = {
          currentPage: 1,
          pageSize: 10,
        }
         this.axios({
             method: 'GET',
             url: '/check/showCheckList',
             params:params,
             header:{
              'Authorization':authorization,
             	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
             	}
           }).then((resp)=>{
            this.tableData = resp.data.data;
            this.pageSize = resp.data.count;
           })
          },
     }
   }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Check/CheckMission.vue